module.exports = __webpack_public_path__ + "static/serkan-0dfd4c837c78b0dd2687df9460f280e5.jpg";